/**
 * Tombol "Order via WhatsApp" di halaman produk untuk pengunjung TAMU.
 *
 * Checkout menuntut login (CartCheckout → "Masuk untuk Membuat Pesanan"), jadi
 * pengunjung tanpa akun diberi satu jalur pesan: chat ke nomor "Hubungi Admin"
 * toko. Berkas ini hanya memegang GERBANG-nya — bentuk pesan & URL-nya dipakai
 * bersama mode katalog (`buildCatalogOrderMessage` / `buildCatalogOrderWaUrl`
 * di resellerCatalog.ts), satu format pesan order untuk seluruh app.
 */

/**
 * Tombol WA tamu ditampilkan? Lima lapis, semuanya penolak (AND):
 *
 * 1. `catalogMode` — di katalog reseller white-label, tombol order sudah
 *    menuju nomor RESELLER pemilik katalog lewat jalurnya sendiri; menyelipkan
 *    tombol bernomor toko utama di sana mengambil ordernya.
 * 2. `settingEnabled` — saklar pemilik toko (`guest_wa_order_enabled`).
 *    Beda dengan saudaranya `showPartnerProductCta`, gerbang ini cuma SATU
 *    bendera: tujuan tombolnya nomor "Hubungi Admin" yang selalu ada, bukan
 *    halaman terpisah yang bisa ikut dimatikan.
 * 3. `customerLoading` — sesi pembeli BELUM diketahui. Fail-closed: menebak
 *    "tamu" lebih dulu membuat tombol berkedip muncul-lalu-hilang di mata
 *    pembeli yang sesungguhnya sudah login.
 * 4. `isAuthenticated` — pembeli ber-akun memesan LANGSUNG di toko (harga
 *    grupnya, keranjang, nota). Mengalihkannya ke WhatsApp justru membuang
 *    harga grup yang jadi alasan ia membuat akun.
 * 5. `canAdd` — produk yang tak bisa dipesan (PO ditutup / stok habis / kuota
 *    habis) tak menawarkan jalur pesan apa pun; alasannya sudah tertulis di
 *    tombol keranjang tepat di atasnya, dan chat "mau order" untuk barang yang
 *    tak ada berakhir di admin sebagai pekerjaan menolak.
 *
 * Helper murni & ber-test karena aturannya berlapis dan dua lapis di antaranya
 * fail-closed — persis alasan `showPartnerProductCta` (partnerDirectory.ts)
 * tidak ditulis inline di komponen.
 */
export function showGuestWaOrder(input: {
  catalogMode: boolean;
  settingEnabled: boolean;
  customerLoading: boolean;
  isAuthenticated: boolean;
  canAdd: boolean;
}): boolean {
  if (input.catalogMode) return false;
  if (!input.settingEnabled) return false;
  if (input.customerLoading) return false;
  if (!input.canAdd) return false;
  return !input.isAuthenticated;
}
